import { render, staticRenderFns } from "./restoreOccupy.vue?vue&type=template&id=0018cf0a&scoped=true"
import script from "./restoreOccupy.vue?vue&type=script&lang=js"
export * from "./restoreOccupy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018cf0a",
  null
  
)

export default component.exports